import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import update from 'react-addons-update'
import PropTypes from 'prop-types'

import axios from 'axios'

import FaClose from 'react-icons/fa/times-circle'
import FaCaretDown from 'react-icons/fa/caret-down'
import FaShare from 'react-icons/fa/share-square-o'
import FaPlus from 'react-icons/fa/plus'

const errorGenericMsg = 'Oops! Something went wrong. Please try again, or contact us at hello@pobble.com.'

@autobind
class WorkResourceModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      status: 'default',
      loading: false,
      newLesson: {}
    }
    axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name=csrf-token]').getAttribute('content')
  }

  closeModal () {
    this.props.onCloseModal()
  }

  resetStatus () {
    this.setState({status: 'default', loading: false})
  }

  newLesson () {
    this.setState({status: 'newLesson'})
  }

  addResource (resourceId, lessonId) {
    axios.post(`/api/v1/lessons/${lessonId}/teaching_resources`, {
      teaching_resource: {id: resourceId}
    })
    .then(() => {
      this.setState({
        status: 'success',
        newLesson: { id: lessonId }
      })
    })
    .catch(err => {
      const message = err.status === 409
        ? 'Oops! This resource is already in this lesson.'
        : errorGenericMsg
      alert(message)
    })
  }

  addToNewLesson () {
    this.setState({loading: true})
    axios.get('/teacher/lessons/new_lesson.json').then(resp => resp.data.lesson).then(lesson => axios.post('/teacher/lessons.json', update(lesson, {title: {$set: this.state.newLesson.title}}))).then((resp) => {
      this.setState({newLesson: resp.data, loading: false})
      this.addResource(this.props.resource.id, this.state.newLesson.id)
    })
    .catch(() => alert(errorGenericMsg))
  }

  handleNewLessonTitle (event) {
    this.setState({newLesson: {title: event.target.value}})
  }

  render () {
    let {lessons, resource} = this.props

    var resourceContent = resource.text_sources[0].content && resource.text_sources[0].content.length > 300
      ? resource.text_sources[0].content.substring(0, 300) + '...'
      : resource.text_sources[0].content

    var textSources = resource.text_sources && resource.text_sources.map((text) =>
      <div>
        <h5>{text.title}</h5>
        <p>{text.content}</p>
      </div>
    )

    var lessonsList = lessons.slice(0, 5).map((lesson) => {
      return (
        <li key={lesson.id}><a onClick={() => this.addResource(resource.id, lesson.id)}>{lesson.title}</a></li>
      )
    })

    return (
      <div className={`resource__modal resource__modal--${this.state.status} resource--modal modal-dialog`}>
        <div className='modal-content'>
          {this.state.status !== 'success' && <div className='modal-header'>
            {this.state.status === 'default' && <h4 className='modal-title'>{resource.title}</h4>}
            {this.state.status === 'newLesson' && <h4 className='modal-title'>Add resource to new lesson</h4>}
            <span className='modal__close' onClick={this.closeModal}>
              <FaClose />
            </span>
          </div>}
          {this.state.status === 'default' && <div className='resource__modal__body modal-body'>
            <div className='resource__side--image'>
              {resource.media_sources.length > 0 && <img src={resource.media_sources[0].original_media_url} />}
            </div>
            <div className='resouce__side--body'>
              {resource.year_groups.length > 0 && <div className='resource__subheader clearfix'>
                <div className='resource__age pull-left'>{resource.year_groups || 'All age ranges'}</div>
              </div>}
              <div className='resource__modal__title'>{resource.title}</div>
              <div className='resource__source'>
                {resource.paid_content && <b ng-hide='resource.paid_content'>Free&nbsp;</b>}content provided by:&nbsp;
                <a href={resource.source_url} target='_blank'>
                  <span className={'resource__source__icon resource__source__icon--' + resource.source_type_key} /> <span className='resource__source__type'>{resource.source_type}</span>
                </a>
              </div>
              {resource.text_sources.length === 1 && <div className='resource__modal__desc'>
                {resourceContent} {resource.source_url && <a href={resource.source_url} target='_blank'>Learn more</a>}
              </div>}
              {resource.text_sources.length > 1 && <div className='resource__modal__desc'>
                {textSources}
              </div>}
            </div>
          </div>}
          {this.state.status === 'success' && <div className='modal-body resource__modal--success__body'>
            <p className='resource__modal--success__title'>Great!</p>
            <p className='resource__modal--success__subtitle'>The resource has been added to the lesson</p>
            <a href={'/teacher/lessons/' + this.state.newLesson.id} className='btn btn-primary'>Go to lesson</a>
            <button className='btn btn-default' onClick={this.closeModal}>Find more resources</button>
          </div>}
          {this.state.status === 'newLesson' && <div className={this.state.loading ? 'resource__modal--create modal-body spinner' : 'resource__modal--create modal-body'}>
            {!this.state.loading && <div className='form-group'>
              <label htmlFor='newLessonTitle'>Enter a title for your lesson:</label>
              <input type='text' className='form-control' id='newLessonTitle' placeholder='Enter name here' onChange={this.handleNewLessonTitle} />
            </div>}
          </div>}
          {this.state.status !== 'success' && <div className='modal-footer'>
            {this.state.status === 'newLesson' && <div className='btn-toolbar pull-right'>
              <button type='button' className='btn btn-default' onClick={this.resetStatus}>Cancel</button>
              <button type='button' className='btn btn-primary' onClick={this.addToNewLesson} disabled={this.state.newLesson.title === ''}>Create Lesson</button>
            </div>}
            {this.state.status === 'default' && <div>
              {resource.source_url && <a className='resource__modal__external-link' href={resource.source_url} target='_blank'>
                View on {resource.source_type} <FaShare />
              </a>}
              {lessons && !lessons.length && <button className='btn btn-primary' onClick={this.newLesson}>
                <FaPlus /> Add to a new Lesson
              </button>}
              {lessons.length > 0 && <div className='btn-group dropdown__wrapper'>
                <label htmlFor='resourceLessons' className='btn btn-primary dropdown-toggle'>
                  <FaPlus />&nbsp;
                  Add to lesson &nbsp;
                  <div className='btn__separator'>
                    <FaCaretDown />
                  </div>
                </label>
                <input type='checkbox' id='resourceLessons' hidden />
                <ul className='dropdown__menu dropdown__menu--top dropdown__menu--right'>
                  <li>Add this resource to an open lesson:</li>
                  {lessonsList}
                  <li role='separator' className='divider' />
                  <li><div className='resource__modal__add-lesson' onClick={this.newLesson}><FaPlus /> Add to a new lesson</div></li>
                </ul>
              </div>}
            </div>}
          </div>}
        </div>
      </div>
    )
  }
}

export default WorkResourceModal

WorkResourceModal.propTypes = {
  resource: PropTypes.object,
  lessons: PropTypes.array,
  onCloseModal: PropTypes.func
}



// WEBPACK FOOTER //
// ./components/work/WorkResourceModal.js